<template>
	<el-container class="el-container" >
	    <el-aside style="background-color: #447FE3;border-top-right-radius: 30px;" :width="isCollapse ? '64px' : '200px'" class="el-aside-container"> <!-- :default-active="activeIndex" -->
			<div class="toggle-logo" @click="collapseMenu">
				<el-image :style="{with : isCollapse ? '60px' : '100px',height : '60px'}" :src=" isCollapse ? shortleftlogourl : leftlogourl" ></el-image>
				<p v-show="!isCollapse">节众物管平台 {{systemname}}</p>
				<p v-show="isCollapse">{{systemname}}</p>
			</div>
			<!-- <div class="toggle-button" @click="collapseMenu">
				<i size="20" :class="menucollapicon"></i>
			</div> -->
			<el-menu style="border-right: none !important;" @select="menuSelected" :unique-opened="true" :router="true" class="el-menu-container" background-color="#447FE3" text-color="#fff"
				@open="handleOpen" @close="handleClose" :collapse="isCollapse">
				<div v-for="(item) in menus" :key="item.id">
					<el-menu-item v-if="item.submenu == undefined || item.submenu == null || item.submenu.length == 0 " :index="item.id">
						<i :class="item.icon"></i>
						<span slot="title">{{item.name}}</span>
					</el-menu-item>
					<el-submenu v-else :index="item.id">
						<template slot="title">
							<i :class="item.icon"></i>
							<span v-show="!isCollapse" slot="title">{{item.name}}</span>
						</template>
						<el-menu-item-group v-for="(submenu,subidx) in item.submenu" :key="subidx">
							<el-menu-item :index="submenu.id">{{submenu.name}}</el-menu-item>
						</el-menu-item-group>
					</el-submenu>
				</div> 
			</el-menu>	
		</el-aside>
		<div :style="{width : isCollapse ? 'calc( 100% - 64px)' : 'calc( 100% - 200px)', float : 'right'}">
			<SysHeader></SysHeader>
			<router-view />
		</div>
	</el-container>
</template>

<script>
	import SysHeader from '../home/header' 
	import { sysname } from '/public/sysname'
	export default {
		name : 'MenuList',
		data() {
			return {
				leftlogourl : "logo.png",
				shortleftlogourl : "favicon.ico",
				//activeIndex: this.$route.path,
				bgcolor : '#FFF  !important',
				menucollapicon : 'el-icon-d-arrow-left',
				isCollapse: false,
				systemname : '',
				menus : [
					{
						id : 'PointSetList',
						name: '一键开关管理',
						icon: 'el-icon-s-order yh-menu-icon-color',
						url : 'pointsetlist',
					},
					{
						id : 'ReportMng',
						name: '报表管理',
						icon: 'el-icon-notebook-1 yh-menu-icon-color',
						submenu : [
							{
								id : 'HisSetList',
								name : '报表点位管理',
								url: 'hissetlist',
							},
							{
								id : 'ReportList',
								name : '报表数据',
								url: 'reportlist',
							},
							{
								id : 'AirTime',
								name : '空调时间统计',
								url: 'airtime',
							},
							{
								id : 'AirTimeHour',
								name : '空调统计(两小时)',
								url: 'airtimehour',
							},
							{
								id : 'PointHistory',
								name : '点位历史数据',
								url: 'pointhistory',
							},
							{
								id : 'OffLine',
								name : '离线空调',
								url: 'offline',
							},
						]
					},
					{
						id : 'SysMan',
						name: '系统管理',
						icon: 'el-icon-setting yh-menu-icon-color',
						submenu : [
							{
								id : 'SysConfigList',
								name : '系统配置',
								url: 'sysconfiglist',
							},
							{
								id : 'OrgTree',
								name : '校区组织',
								url: 'orgtree',
							},
							{
								id : 'SysRole',
								name : '角色管理',
								url: 'sysrole',
							},
							{
								id : 'SysUser',
								name : '用户管理',
								url: 'sysuser',
							},
							{
								id : 'LocTypeList',
								name : '位置类型',
								url: 'loctypelist',
							},
							{
								id : 'CalcPointList',
								name : '计算点位管理',
								url: 'calcpointlist',
							},
							{
								id : 'RechargeList',
								name: '控制器充值记录',
								icon: 'el-icon-s-finance yh-menu-icon-color',
								url : 'rechargelist',
							},
						]
					},
					{
						id : 'SysDev',
						name: '设备管理',
						icon: 'el-icon-s-operation yh-menu-icon-color',
						submenu : [
							{
								id : 'DevType',
								name : '设备类型型号',
								url: 'devtype',
							},
							{
								id : 'DevList',
								name : '采集点位',
								url: 'devlist',
							},
							{
								id : 'LocationList',
								name : '位置管理',
								url: 'locationlist',
							},
							{
								id : 'RealDev',
								name : '设备管理',
								url: 'realdev',
							},
							{
								id : 'ChinaSchool',
								name : '校区分布',
								url: 'chinaschool',
							},
						]
					},
					
				],
				
			}
		},
		mounted() {
			this.systemname = localStorage.getItem("cityname")
		},
		components: {
			SysHeader
		},
		methods: {
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			},
			menuSelected(key,path){
				console.log(key,path)
				//this.$emit('menuSelect',key)
			},
			collapseMenu(){
				if(this.isCollapse){
					this.isCollapse = false
					this.menucollapicon = 'el-icon-d-arrow-left'
				}else{
					this.isCollapse = true
					this.menucollapicon = 'el-icon-d-arrow-right'
				}
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	/* body {
		background-color: var(bgcolor);
	} */
	.el-container {
		height: 100%;
		.el-aside-container {
			height: 100%;
			border-top-right-radius: 30px;
			background-color: '#447FE3';
			.el-menu-container {
				height: 100%;
				min-height: 800px;
				color: #fff !important;  
				.el-submenu{
					.el-submenu__title{
						.el-submenu__icon-arrow{
							color: #fff !important; 
						}
					}
				}
			}
		}
	}
	/* .el-menu-vertical-demo:not(.el-menu--collapse) {
	    width: 200px;
	    min-height: 800px;
		color: #fff !important;  
	} */
	.yh-menu-icon-color{
		color: #fff;
	}
	.el-submenu__title i {
	    color: #fff !important;
	}
	.toggle-button{
		font-size: 14px;
		color: #fff;
		text-align: center;
	}
	.toggle-logo{
		font-size: 14px;
		color: #fff;
		margin-top: 10px;
		border-top-right-radius: 10px;
		text-align: center;
		border-bottom: 1px solid #f1f1ff;
	}
	.el-submenu__icon-arrow{
		color: #fff !important;
	}
	
</style>